module.exports = __webpack_public_path__ + "static/media/elwyn_cruz.dfec4408.png";